import { connect } from 'react-redux'

import { toggleSignalDetail, signalsOpenCiaNews } from './actions'
import { openLinkagesById } from '../../../../../Linkages/actions'
import { setupDistraintsById } from '../../../../../Distraints/actions'

export default connect(null, {
    toggleSignalDetail,
    openLinkagesById,
    setupDistraintsById,
    signalsOpenCiaNews,
})
